import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => (
  <Box component="footer" sx={{ p: 2, bgcolor: 'grey.200', textAlign: 'center' }}>
    <Typography variant="body2">&copy; {new Date().getFullYear()} AdSpace Admin</Typography>
  </Box>
);

export default Footer;
